<template>
    <div class="header">
        <!-- 折叠按钮 -->
        <div class="collapse-btn" @click="collapseChage">
            <i v-if="!collapse" class="el-icon-s-fold"></i>
            <i v-else class="el-icon-s-unfold"></i>
        </div>
        <div class="logo">后台管理系统</div>
        <div class="header-right">
            <div class="header-user-con">
                <!-- 用户头像 -->
                <div class="user-avator">
                    <img src="../assets/img/img.jpg" />
                </div>
                <!-- 用户名下拉菜单 -->
                <el-dropdown class="user-name" trigger="click" @command="handleCommand">
                    <span class="el-dropdown-link">
                        <i class="el-icon-caret-bottom"></i>
                    </span>
                    <template #dropdown>
                        <el-dropdown-menu>
                          <el-dropdown-item divided command="savepass" @click="editPassword">修改密码</el-dropdown-item>
                            <el-dropdown-item divided command="loginout" @click="logout">退出</el-dropdown-item>
                        </el-dropdown-menu>
                    </template>
                </el-dropdown>
              <!-- 密码弹出框 -->
              <el-dialog title="修改密码" v-model="editPassVisible" width="25%">
                <el-form ref="form" label-width="70px">
                  <el-form-item label="密码">
                    <el-input v-model="password" show-password></el-input>
                  </el-form-item>
                </el-form>
                <template #footer>
                <span class="dialog-footer">
                    <el-button @click="editPassVisible = false">取 消</el-button>
                    <el-button type="primary" @click="savePassword">确 定</el-button>
                </span>
                </template>
              </el-dialog>
            </div>
        </div>
    </div>
</template>
<script>
import {setAdminPass} from "@/api/admin";

export default {
    data() {
        return {
            fullscreen: false,
            name: "linxin",
            message: 2,
            editPassVisible:false,
            password:''
        };
    },
    computed: {
        username() {
            let username = localStorage.getItem("ms_username");
            return username ? username : this.name;
        },
        collapse() {
            return this.$store.state.collapse;
        }
    },
    methods: {
        // 用户名下拉菜单选择事件
        handleCommand(command) {
            if (command == "loginout") {
                localStorage.removeItem("ms_username");
                this.$router.push("/login");
            }else{
              this.editPassword()
            }
        },
        // 侧边栏折叠
        collapseChage() {
            this.$store.commit("hadndleCollapse", !this.collapse);
        },
        // 修改密码
      editPassword() {
        this.editPassVisible = true
      },
        logout() {
          localStorage.setItem("memu", null)
          localStorage.setItem("token", undefined)
        },
      savePassword(){
          if(this.password.length < 6){
            this.$message.warning('至少输入六位密码！')
            this.password = ''
          }else{
            setAdminPass(this.password,0).then(res => {
              if (res === true) {
                this.$message.success('保存成功')
                this.editPassVisible = false;
                this.password = ''
              }
              this.getData()
              this.editPassVisible = false;
            })
          }

      }
    },
    mounted() {
        if (document.body.clientWidth < 1500) {
            this.collapseChage();
        }
    }
};
</script>
<style scoped>
.header {
    position: relative;
    box-sizing: border-box;
    width: 100%;
    height: 70px;
    font-size: 22px;
    color: #fff;
}
.collapse-btn {
    float: left;
    padding: 0 21px;
    cursor: pointer;
    line-height: 70px;
}
.header .logo {
    float: left;
    width: 250px;
    line-height: 70px;
}
.header-right {
    float: right;
    padding-right: 50px;
}
.header-user-con {
    display: flex;
    height: 70px;
    align-items: center;
}
.btn-fullscreen {
    transform: rotate(45deg);
    margin-right: 5px;
    font-size: 24px;
}
.btn-bell,
.btn-fullscreen {
    position: relative;
    width: 30px;
    height: 30px;
    text-align: center;
    border-radius: 15px;
    cursor: pointer;
}
.btn-bell-badge {
    position: absolute;
    right: 0;
    top: -2px;
    width: 8px;
    height: 8px;
    border-radius: 4px;
    background: #f56c6c;
    color: #fff;
}
.btn-bell .el-icon-bell {
    color: #fff;
}
.user-name {
    margin-left: 10px;
}
.user-avator {
    margin-left: 20px;
}
.user-avator img {
    display: block;
    width: 40px;
    height: 40px;
    border-radius: 50%;
}
.el-dropdown-link {
    color: #fff;
    cursor: pointer;
}
.el-dropdown-menu__item {
    text-align: center;
}
</style>
